export const CONTROL_LOT_STATUS_VALUES = [
  'OPEN',
  'CLOSED',
  'ACCEPTED',
  'REJECTED',
] as const;

export type ControlLotStatus = typeof CONTROL_LOT_STATUS_VALUES[number];

export const POUR_RECOMMENDATION_REASONS = {
  STR_NOT_FOUND: 'qualityControl.pourRecommendations.strNotFound',
  CONCRETE_NOT_RESOLVED: 'qualityControl.pourRecommendations.concreteNotResolved',
  NO_SAMPLE_DATE: 'qualityControl.pourRecommendations.noSampleDate',
  NO_MATCH: 'qualityControl.pourRecommendations.noMatch',
  CANDIDATES_FOUND: 'qualityControl.pourRecommendations.candidatesFound',
} as const;

/**
 * Levenshtein distance threshold for fuzzy matching of structural element refs.
 * ≤ this value → WARNING state (likely same element, minor typo).
 * > this value  → ERROR state (probably different element).
 * All structuralElementRef mismatches are non-blocking regardless of state.
 */
export const ELEMENT_REF_LEVENSHTEIN_THRESHOLD = 3;

/**
 * Per-check result returned by the lot recommendation engine for each candidate lot.
 * Replaces the old binary confidence ('high'|'medium') + warnings[] model.
 *
 * key   — machine key matching a known check type (volume, timeWindow, etc.)
 * ok    — true when the check passes without concern
 * state — granular 3-level result; 'ok' | 'warning' | 'error'
 *         For binary checks: ok→'ok', fail→'error'.
 *         For structuralElementRef: exact match→'ok', fuzzy→'warning', no match→'error'.
 * detail — human-readable context string (e.g. '45 / 50 m³'), optional
 */
export interface LotCheck {
  key: 'volume' | 'timeWindow' | 'samplingRate' | 'minSamples' | 'structuralElementRef';
  ok: boolean;
  state: 'ok' | 'warning' | 'error';
  detail?: string;
}
